<div class="content-section mx-auto">
  <section class="flex flex-col sm:flex-row min-h-0 h-fit py-2">
    <header class="sm:hidden">
      <!-- <label class="btn btn-circle swap swap-rotate sm:hidden"> -->
      <!-- this hidden checkbox controls the state -->
      <!-- <input type="checkbox" /> -->

      <!-- hamburger icon -->
      <!-- <svg
          class="swap-off fill-current"
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 512 512"
        >
          <path
            d="M64,384H448V341.33H64Zm0-106.67H448V234.67H64ZM64,128v42.67H448V128Z"
          />
        </svg> -->

      <!-- close icon -->
      <!-- <svg
          class="swap-on fill-current"
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 512 512"
        >
          <polygon
            points="400 145.49 366.51 112 256 222.51 145.49 112 112 145.49 222.51 256 112 366.51 145.49 400 256 289.49 366.51 400 400 366.51 289.49 256 400 145.49"
          />
        </svg> -->
      <!-- </label> -->
    </header>
    <app-category-filters
      class="contents"
      [categorySlug]="browseResponse()?.categorySlug || ''"
      [activeSubSlug]="activeSubSlug()"
      [activeSub2Slug]="activeSub2Slug()"
      [preservedQueryParams]="filterQueryParams()"
      [activeFilters]="currentFilters()"
      [subCategories]="browseResponse()?.subCategories || []"
      [brands]="browseResponse()?.brands || []"
      [priceRange]="browseResponse()?.priceRange || { minPrice: 0, maxPrice: 1000 }"
      (filtersChanged)="onFiltersChanged($event)"
    />
    <div class="sm:grow space-y-4 py-2">
      <header
        class="flex flex-col sm:flex-row items-start justify-between sm:items-center gap-2"
      >
        <div>
          <span class="text-blue font-semibold"> {{ totalCount() }} </span>
          <span> {{ 'Items in' | translate }} </span>
          <span class="font-bold">
            {{ browseResponse()?.categoryName || ('Loading...' | translate) }}
          </span>
        </div>
        <fieldset
          class="flex gap-x-1 sm:gap-x-2 justify-between sm:justify-start w-full sm:w-auto"
        >
          <label class="label" for="sortBySelect">
            {{ 'Sort By' | translate }}:
          </label>
          <select
            id="sortBySelect"
            class="select w-40"
            (change)="onSortChange($event)"
            [value]="sortBy()"
          >
            <option value="latest">{{ 'Latest' | translate }}</option>
            <option value="priceAsc">{{ 'Cheapest' | translate }}</option>
            <option value="priceDesc">{{ 'Most Expensive' | translate }}</option>
            <option value="nameAsc">{{ 'Name (A-Z)' | translate }}</option>
            <option value="nameDesc">{{ 'Name (Z-A)' | translate }}</option>
            <!-- <option value="rating">Rating</option> -->
          </select>
        </fieldset>
      </header>
      @if (isLoading()) {
        <div class="text-center py-4 w-full">
          {{ 'Loading more products...' | translate }}
        </div>
      } @else {
        <div class="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          @for (item of products(); track item.id) {
            <app-product-card [data]="mapProduct(item)" />
          }
        </div>
      }
    </div>
  </section>
</div>
